import View from '@picsart/view/View';
import { FontWeights, Spacings } from '@picsart/cascade';
import { useTranslator } from '@picsart/rc/services/localization';
import { Text, TextElementTypes, TypographyHorizontalAlign } from '@picsart/text';
import { useState } from 'react';
import Image from '@picsart/image/Image';

import { PreviewModalImage, PreviewModalImageBox, PreviewModalZoomWrapper, PreviewModalZoomDesktopActions } from 'pages/Batch/components/PreviewModal/ModalSlices';
import usePreviewModal from 'pages/Batch/components/PreviewModal/usePreviewModal';

import useStyles from './styles';

interface IBeforeAfterModalContentProps {
    beforeImageSrc: string;
    afterImageSrc: string;
}
const BeforeAfterModalContent = ({ beforeImageSrc, afterImageSrc }: IBeforeAfterModalContentProps) => {
  const { isImageLoaded } = usePreviewModal();
  const [value, setValue] = useState(50);
  const classes = useStyles({
    value,
  });
  const translate = useTranslator();

  return (
    <>
      <PreviewModalImageBox>
        <PreviewModalZoomWrapper>
          <PreviewModalImage imageSrc={beforeImageSrc} />
          { isImageLoaded && (
            <Image
              src={afterImageSrc}
              className={classes.secondImage}
            />
          )}
        </PreviewModalZoomWrapper>
        { isImageLoaded && (
          <View
            className={classes.beforeAfterWrapper}
          >
            <View justifyContent="space-between" padding={Spacings.s16} flex={1}>
              <Text
                className={classes.labelText}
                weight={FontWeights.Medium}
                elementType={TextElementTypes.Span}
                align={TypographyHorizontalAlign.Center}
              >
                {translate('Before')}
              </Text>
              <Text
                className={classes.labelText}
                weight={FontWeights.Medium}
                elementType={TextElementTypes.Span}
                align={TypographyHorizontalAlign.Center}
              >
                {translate('After')}
              </Text>
            </View>
            <View
              className={classes.rangeBox}
            >
              <View className={classes.lineIndicator} />
              <input
                className={classes.slicer}
                type="range"
                value={value}
                min={0}
                max={100}
                onChange={event => setValue(Number(event.target.value))}
              />
            </View>
          </View>
        )}
      </PreviewModalImageBox>
      <PreviewModalZoomDesktopActions />
    </>
  );
};

export default BeforeAfterModalContent;
